import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { rights } from '@services/api'

export class rightsStore extends StoreExt {
    @observable list = []
    @observable filteredList = []
    @observable filters = {}

    @action
    getRightsList = async params => {
        const { data: list } = await rights.getList({ ...params })
        runInAction(() => {
            this.list = list
        })
    }

    @action
    applyFilters = () => {
        const newList = this.list.filter(item => {
            let filter = true
            if ('name' in this.filters) {
                filter = item.name.includes(this.filters['name'])
            }
            if (filter && 'relevant' in this.filters) {
                if (this.filters['relevant'] === 'RELEVANT') {
                    filter = !!(item.__meta__.right_parameters_count !== 0)
                } else {
                    filter = !(item.__meta__.right_parameters_count !== 0)
                }
            }
            return filter
        })
        runInAction(() => {
            this.filteredList = newList
        })
    }

    @action
    addFilter = (name, value) => {
        const newFilters = { ...this.filters }
        if (name in newFilters && !value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = { ...newFilters }
            this.applyFilters()
        })
    }

    @action
    resetFilters = () => {
        this.filters = {}
        this.applyFilters()
    }

    @action
    resetRights = () => {
        this.list = []
        this.filteredList = []
    }
}

export default remotedev(new rightsStore())
